import log from "./log";

class dfpReload {
	constructor() {
		this.validateAbd = this.validateAbd.bind(this);
		this.run = this.run.bind(this);
		this.runChecker = this.runChecker.bind(this);

		this.isVisible = this.isVisible.bind(this);
		this.movement = this.movement.bind(this);
		this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

		this.scrollSeconds = 0;
		this.allowScrollCount = true;
		this.timer = false;

		$("body").on("abd-event", this.validateAbd);

		// Check visibility Setup
		let hidden;
		let visibilityChange;
		if (typeof document.hidden !== "undefined") {
			// Opera 12.10 and Firefox 18 and later support
			hidden = "hidden";
			visibilityChange = "visibilitychange";
		} else if (typeof document.msHidden !== "undefined") {
			hidden = "msHidden";
			visibilityChange = "msvisibilitychange";
		} else if (typeof document.webkitHidden !== "undefined") {
			hidden = "webkitHidden";
			visibilityChange = "webkitvisibilitychange";
		}

		if (
			typeof document.addEventListener === "undefined"
			|| typeof document.hidden === "undefined"
		) {
			log(
				__filename,
				"Browser doesn't support eventListener or hidden detection ",
				"info",
			);
			this.isInTab = true;
		} else {
			document.addEventListener(
				visibilityChange,
				this.handleVisibilityChange,
				false,
			);
			this.isInTab = !document.hidden;
		}
	}

	// eslint-disable-next-line class-method-use-this
	runChecker() {
		window.adsCounter = {};
		googletag.cmd.push(() => {
			googletag.pubads().addEventListener("slotRenderEnded", (event) => {
				const slotId = event.slot.getSlotElementId();
				log(__filename, `Received  Ad ${slotId}`, "log", false);
				if (typeof window.adsCounter[slotId] === "undefined") {
					window.adsCounter[slotId] = 0;
				}
				log(
					__filename,
					`${slotId} | window.adsCounter[slotId] | ${
						window.adsCounter[slotId]
					}`,
					"log",
					false,
				);
				if (window.adsCounter[slotId] < 2) {
					log(
						__filename,
						`Ad ${slotId} | event.isEmpty  | ${event.isEmpty}`,
						"log",
						false,
					);
					if (event.isEmpty) {
						log(__filename, `Refreshing empty Ad ${slotId}`, "log", false);
						googletag.pubads().refresh(window.adtags[slotId]);
						window.adsCounter[slotId] += 1;
					}
				}
			});
		});
	}

	validateAbd() {
		if (!window.abd) {
			this.run();
			if (window.mobile) {
				this.runChecker();
			}
		} else {
			log(__filename, "Adblock detected, cant start", "info");
		}
	}

	handleVisibilityChange() {
		this.isInTab = !document.hidden;
		log(
			__filename,
			`handleVisibilityChange isInTab ? = ${this.isInTab}`,
			"log",
			false,
		);
	}

	isVisible(el) {
		el = document.getElementById(el);
		if (el == null || !this.isInTab) {
			return;
		}

		const rect = el.getBoundingClientRect();
		const elemTop = rect.top;
		const elemBottom = rect.bottom;

		// Only completely visible elements return true:
		// const isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
		// Partially visible elements return true:
		const isVisible = elemTop < window.innerHeight && elemBottom >= 0;
		return isVisible;
	}

	movement() {
		log(__filename, "Movement detected", "log", false);
		if (!this.allowScrollCount) {
			clearTimeout(this.timer);
		}

		this.allowScrollCount = false;
		this.scrollSeconds = 0;

		this.timer = setTimeout(() => {
			this.allowScrollCount = true;
		}, 1024);
	}

	run() {
		log(__filename, "Run Event");
		if (
			typeof window.watchAds === "undefined"
			|| window.adtags == "undefined"
		) {
			log(__filename, "No ads to watch or no config var found");
			return;
		}
		const timers = {};
		const maxTimers = {};

		const adsUnits = Object.keys(window.watchAds.adsUnits);
		for (const ad of adsUnits) {
			timers[ad] = { time: 0, reloads: 0 };
			maxTimers[ad] = window.watchAds.adsUnits[ad];
		}

		// Mirar acciones del usuario
		window.addEventListener("scroll", this.movement);
		window.addEventListener("click", this.movement);
		window.addEventListener("mousemove", this.movement);
		window.addEventListener("touchstart", this.movement);

		// Monitor cada 1s

		setInterval(() => {
			log(__filename, "Updating Ads", "log", false);
			const toReload = [];
			const toReloadId = [];
			if (this.allowScrollCount) {
				this.scrollSeconds += 1;
			}

			for (const ad of adsUnits) {
				if (this.isVisible(ad)) {
					//	log(__filename, `${ad} is visible`);
					timers[ad].time += 1;

					log(
						__filename,
						`${timers[ad].time} >= ${maxTimers[ad]} ? `,
						"log",
						false,
					);
					log(
						__filename,
						`${this.scrollSeconds} <= ${window.watchAds.inactiveTime} ?`,
						"log",
						false,
					);
					log(
						__filename,
						`${timers[ad].reloads} < ${window.watchAds.maxReloads} ?`,
						"log",
						false,
					);

					if (
						timers[ad].time >= maxTimers[ad]
						&& this.scrollSeconds <= window.watchAds.inactiveTime
						&& timers[ad].reloads < window.watchAds.maxReloads
					) {
						log(__filename, `${ad} should refresh`, "log", false);
						toReload.push(window.adtags[ad]);
						toReloadId.push(ad);
						timers[ad].time = 0;
						timers[ad].reloads += 1;
					}
				}
			}

			if (toReload.length > 0) {
				log(__filename, `Refreshing Ads`);
				if (typeof googletag.pubads === "function") {
					googletag.pubads().refresh(toReload);
					toReloadId.forEach((element) => {
						$(window).trigger(`DFP-reloading-${element}`);
					});
				}
			}
		}, 1000);
	}
}

export default dfpReload;
